import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getProductiveCycleStageTemplateList as getProductiveCycleStageTemplateListApi,
	getProductiveCycleStageTemplate as getProductiveCycleStageTemplateApi,
	addNewProductiveCycleStageTemplate as addNewProductiveCycleStageTemplateApi,
	updateProductiveCycleStageTemplate as updateProductiveCycleStageTemplateApi,
	deleteProductiveCycleStageTemplate as deleteProductiveCycleStageTemplateApi,
	existsProductiveCycleStageTemplate as existsProductiveCycleStageTemplateApi,
} from '../../helpers/establishment/backend_helper';


export const getProductiveCycleStageTemplateList = createAsyncThunk('productiveCycleStageTemplate/getProductiveCycleStageTemplateList', async (params) => {
	try {
		const response = getProductiveCycleStageTemplateListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getProductiveCycleStageTemplate = createAsyncThunk('productiveCycleStageTemplate/getProductiveCycleStageTemplate', async productive_cycle_stage_template_id => {
	try {
		const response = getProductiveCycleStageTemplateApi(productive_cycle_stage_template_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewProductiveCycleStageTemplate = createAsyncThunk('productiveCycleStageTemplate/addNewProductiveCycleStageTemplate', async productive_cycle_stage_template => {
	try {
		const response = addNewProductiveCycleStageTemplateApi(productive_cycle_stage_template);
		toast.success('Estado ciclo productivo agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar productive_cycle_stage_template.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateProductiveCycleStageTemplate = createAsyncThunk('productiveCycleStageTemplate/updateProductiveCycleStageTemplate', async (productive_cycle_stage_template) => {
		try {
			const response = updateProductiveCycleStageTemplateApi(productive_cycle_stage_template);
			toast.success('Estado ciclo productivo actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar productive_cycle_stage_template.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteProductiveCycleStageTemplate = createAsyncThunk('productiveCycleStageTemplate/deleteProductiveCycleStageTemplate', async productive_cycle_stage_template => {
	try {
		const response = await deleteProductiveCycleStageTemplateApi(productive_cycle_stage_template);
		toast.success('Estado ciclo productivo eliminado exitosamente.', { autoClose: 3000 });
		return { productive_cycle_stage_template, ...response };
	} catch (error) {
		toast.error('Error al eliminar productive_cycle_stage_template.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const existsProductiveCycleStageTemplate = createAsyncThunk('productiveCycleStageTemplate/existsProductiveCycleStageTemplate', async (params) => {
	try {
		const response = existsProductiveCycleStageTemplateApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});